var gql = require("@apollo/client").gql;

const NEWS_ONE = gql`
	query NewsOne($id: Int!, $region_url: String!) {
		newsOne(id: $id, region_url: $region_url) {
			id
			title
			text
			date
			is_action
			image_lg
			image_md
			image_sm
			image_xs
			image_preview_lg
			image_preview_md
			image_preview_sm
			image_preview_xs
			image_preview
			provider {
				id
				name
				url_name
				mobile_operator
			}
		}
	}
`;

module.exports = NEWS_ONE;
